import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { CONFIG_STUDIO_API } from "./apiRoutes";

interface mutateProps {
  communityId: string;
  documentTypeId: string;
  data: FieldValues
}

const mutateUpdateConfigFields = async ({
  communityId,
  documentTypeId,
  data,
}: mutateProps) => {
  return await axiosAuth.put(`${CONFIG_STUDIO_API}/config/${communityId}/${documentTypeId}`, data);
};

const useUpdateConfigFieldsMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateConfigFields,
    ...queryParams,
  });

export default useUpdateConfigFieldsMutation;
